import { Fragment, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function ModalEditInformationsMulti({ onSubmit, products_selected }) {
    const [isOpen, setIsOpen] = useState(false);
    const [exchange_type_price, setExchangeTypePrice] = useState("rate");
    const [exchange_rate_price, setExchangeRatePrice] = useState(1);
    const [exchange_type_variants, setExchangeTypeVariants] = useState("rate");
    const [exchange_rate_variants, setExchangeRateVariants] = useState(1);
    const [change_type_quantity_variants, setChangeTypeQuantityVariants] = useState("rate");
    const [change_rate_quantity_variants, setChangeRateQuantityVariants] = useState(1);
    const { t } = useTranslation();

    const onClose = () => {
        setIsOpen(false);
    };

    const handleSubmit = () => {
        onSubmit({ exchange_type_variants, exchange_rate_variants, change_type_quantity_variants, change_rate_quantity_variants, exchange_type_price, exchange_rate_price });
        onClose();
    };

    const onKeyPress = (e) => {
        if ((/^[0-9.]+$/).test(e)) {
            e.preventDefault();
        }
    }

    const onChange = (e) => {
        if (e.target.name === "exchange_type_price") {
            setExchangeTypePrice(e.target.value);
        }
        if (e.target.name === "exchange_rate_price") {
            setExchangeRatePrice(e.target.value);
        }
        if (e.target.name === "exchange_type_variants") {
            setExchangeTypeVariants(e.target.value);
        }
        if (e.target.name === "exchange_rate_variants") {
            setExchangeRateVariants(e.target.value);
        }
        if (e.target.name === "change_type_quantity_variants") {
            setChangeTypeQuantityVariants(e.target.value);
        }
        if (e.target.name === "change_rate_quantity_variants") {
            setChangeRateQuantityVariants(e.target.value);
        }
    }

    return (
        <Fragment>
            <button
                className="btn btn-sm btn-info me-2 mb-2"
                data-bs-toggle="modal"
                data-bs-target="#kt_modal_create_app"
                id="kt_toolbar_primary_button"
                onClick={() => setIsOpen(true)}
                disabled={products_selected <= 0}
            >
                <i className="ki-outline ki-notepad-edit fs-2"></i>
                {t("Edit Informations")} {products_selected}
            </button>
            <Modal
                centered={true}
                size="lg"
                toggle={() => {
                    onClose();
                }}
                isOpen={isOpen}
            >
                <div className="modal-header">
                    <h2 className="mb-0 text-info">{t("Edit informations")}</h2>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
                        <i
                            className="ki-outline ki-cross fs-1"
                            onClick={() => {
                                onClose();
                            }}
                        ></i>
                    </div>
                </div>
                <ModalBody>
                    <div className="row">
                        <div className="col-6 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span className="required">{t("Exchange Type Variants")}</span>
                            </label>
                            <select
                                className="form-select"
                                name="exchange_type_variants"
                                onChange={(e) => { onChange(e) }}
                                value={exchange_type_variants}
                            >
                                {/* {
                                    place !== "groupbutton" ? */}
                                        <Fragment>
                                            <option value="rate">{t("Rate")}</option>
                                            <option value="percent">{t("Percent")}</option>
                                            <option value="plus">{t("Plus")}</option>
                                        </Fragment>
                                    {/* : ""
                                } */}
                                <option value="fix">{t("Fix")}</option>
                                <option value="custom">{t("Custom")}</option>
                            </select>
                        </div>
                        <div className="col-6 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span className="required">{t("Exchange Rate Variants")}</span>
                            </label>
                            <input
                                type={exchange_type_variants === "custom" ? "text" : "number"}
                                className="form-control"
                                placeholder={t("Exchange Rate")}
                                name="exchange_rate_variants"
                                onChange={(e) => { onChange(e) }}
                                value={exchange_rate_variants}
                                onKeyPress={exchange_type_variants === "custom" ? (e) => onKeyPress(e) : undefined}
                            />
                            {
                                exchange_type_variants === "custom" ? 
                                    <div className="form-text">
                                        {`{price}`} - Example: {`{price}`}*2+3
                                        <i className="ki-duotone ki-copy cursor-pointer ms-1" onClick={() => navigator.clipboard.writeText(`{price}`)}></i>
                                    </div>
                                : ""
                            }
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span className="required">{t("Change Type Quantity Variants")}</span>
                            </label>
                            <select
                                className="form-select"
                                name="change_type_quantity_variants"
                                onChange={(e) => { onChange(e) }}
                                value={change_type_quantity_variants}
                            >
                                <option value="rate">{t("Rate")}</option>
                                <option value="plus">{t("Plus")}</option>
                                <option value="fix">{t("Fix")}</option>
                            </select>
                        </div>
                        <div className="col-6 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span className="required">{t("Change Rate Quantity Variants")}</span>
                            </label>
                            <input
                                type="number"
                                className="form-control"
                                placeholder={t("Change Rate")}
                                name="change_rate_quantity_variants"
                                onChange={(e) => { onChange(e) }}
                                value={change_rate_quantity_variants}
                                onKeyPress={(e) => onKeyPress(e)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span className="required">{t("Exchange Type Price")}</span>
                            </label>
                            <select
                                className="form-select"
                                name="exchange_type_price"
                                onChange={(e) => { onChange(e) }}
                                value={exchange_type_price}
                            >
                                {/* {
                                    place !== "groupbutton" ? */}
                                        <Fragment>
                                            <option value="rate">{t("Rate")}</option>
                                            <option value="percent">{t("Percent")}</option>
                                            <option value="plus">{t("Plus")}</option>
                                        </Fragment>
                                    {/* : ""
                                } */}
                                <option value="fix">{t("Fix")}</option>
                                <option value="custom">{t("Custom")}</option>
                            </select>
                        </div>
                        <div className="col-6 d-flex flex-column mb-4 fv-row fv-plugins-icon-container">
                            <label className="d-flex align-items-center fs-6 fw-semibold mb-2">
                                <span className="required">{t("Exchange Rate Price")}</span>
                            </label>
                            <input
                                type={exchange_type_price === "custom" ? "text" : "number"}
                                className="form-control"
                                placeholder={t("Exchange Rate")}
                                name="exchange_rate_price"
                                onChange={(e) => { onChange(e) }}
                                value={exchange_rate_price}
                                onKeyPress={exchange_type_price === "custom" ? (e) => onKeyPress(e) : undefined}
                            />
                            {
                                exchange_type_price === "custom" ? 
                                    <div className="form-text">
                                        {`{price}`} - Example: {`{price}`}*2+3
                                        <i className="ki-duotone ki-copy cursor-pointer ms-1" onClick={() => navigator.clipboard.writeText(`{price}`)}></i>
                                    </div>
                                : ""
                            }
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button
                        type="reset"
                        id="kt_modal_users_search_reset"
                        data-bs-dismiss="modal"
                        className="btn btn-active-light me-3"
                        onClick={() => {
                            onClose();
                        }}
                    >
                        {t("Cancel")}
                    </button>
                    <button
                        onClick={handleSubmit}
                        type="submit"
                        id="kt_modal_users_search_submit"
                        className="btn btn-primary"
                    >
                        {t("Save")}
                    </button>
                </ModalFooter>
            </Modal>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEditInformationsMulti);